import * as React from "react";
import { Stack, alpha } from "@mui/material";
import MessageTextField from "./MessageTextField";


interface IMessageInputHandlerProps {
  messageText: string;
  handleSetMessageText: (val: string) => void;
  addMessage: () => void;
}

const MessageInputHandler: React.FunctionComponent<IMessageInputHandlerProps> = ({
  messageText,
  handleSetMessageText,
  addMessage,
}) => {
  return (
    <Stack
      sx={{
        // borderTop: 1,
        borderColor: (t) => alpha(t.palette.common.black, 0.12),
      }}
    >
      <MessageTextField
        val={messageText}
        handleChange={handleSetMessageText}
        addMessage={addMessage}
      />
    </Stack>
  );
};

export default React.memo(MessageInputHandler);
